import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {inject, observer} from 'mobx-react';
import {action, observable, runInAction} from 'mobx';
import {AttachmentType} from '../../../constants/enums';
import CircularLoader from '../../../components/circularLoader/CircularLoader';
import VideoPlayer from '../../../components/videoPlayer';
import PDFViewer from '../../../components/pdfViewer/PDFViewer';
import WhiteBoardWrapper from "../../studio/whiteboard/WhiteBoardWrapper";
import ChordSheetViewer from "../../../components/chordSheetViewer/ChordSheetViewer";
import {attachedTypeFile} from "../../../utils/commonUtility";

@inject('notationViewerStore', 'projectStore')
@observer
class LessonPreviewContent extends Component {
    @observable isLoading = true;
    @observable isRender = true;
    @observable timestamp = Date.now();

    componentDidMount() {
        if (this.props.file.type === AttachmentType.Image) return;
        /*this.interval = setInterval(action(() => {
            this.isRender = false;
            setTimeout(action(() => {
                this.isRender = true;
            }), 0);
        }), 3000);*/
    }

    //componentWillUnmount() {
    //clearInterval(this.interval);
    //}

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.file && prevProps.file.url !== this.props.file.url) {
            // console.log("file changed : " + this.props.file.url);
            runInAction(() => {
                this.isLoading = true;
                this.isRender = false;
                this.timestamp = Date.now();
            });
            setTimeout(() => {
                    runInAction(() => {
                        this.isRender = true;
                    })
                }, 0
            );
            setTimeout(() => {
                    runInAction(() => {
                        this.isLoading = false;
                    })
                }, 3000
            );
        }
    }

    @action onLoad = () => {
        setTimeout(() => {
                runInAction(() => {
                    this.isLoading = false;
                })
            }, 500
        );
    };

    onClose = () => {
        //clearInterval(this.interval);
        this.props.onClose();
    };

    isTypePdfOrDoc = (type) => {
        return (type === AttachmentType.Doc || type === AttachmentType.Docx || type === AttachmentType.Msword || type === AttachmentType.Pdf);
    }

    cancelCanvas = () => {
        if (this.props.cancelCanvas) {
            this.props.cancelCanvas();
            return;
        }
        this.props.projectStore.editNotationCanvas(false);
    };


    render() {
        const {video, file, isCanvasEditable} = this.props;
        // console.log("Rendering :: " + file);
        let type = attachedTypeFile(file);
        let url = file.url;
        if (!url) {
            url = `/attachments/${file.id}`;
        }
        url = url.replace(/https:\/\/academy\.musico\.io\//g, '');
        if (url.indexOf('/') !== 0) {
            url = '/' + url;
        }

        const encodedUrl = encodeURIComponent(url); //TODO Need to Change!!
        return (
            <Fragment>
                {this.isTypePdfOrDoc(type) && url && <Fragment>
                    {this.isLoading && <CircularLoader/>}
                    {type !== AttachmentType.Pdf && this.isRender &&
                    <iframe title={`preview-${url}-${this.timestamp}`}
                            src={`https://docs.google.com/viewer?url=${encodedUrl}&embedded=true&timestamp=${this.timestamp}`} onLoad={this.onLoad}/>
                    }
                    {type === AttachmentType.Pdf &&
                    <PDFViewer isLoading={this.isLoading}
                               file={file}
                               id={file.id}
                               page={file.page - 1 || 0}
                               numPage={file.numPages || 1}
                               annotations={file.annotations}
                               canvas={file.canvas}
                               rotate={file.rotate}
                               url={url}
                               onLoad={this.onLoad}
                               onError={this.onLoad}
                               cancelCanvas={this.cancelCanvas}
                               isCanvasEditable={isCanvasEditable}
                    />}
                </Fragment>}
                {type === AttachmentType.ChordPro && url &&
                    <ChordSheetViewer url={url} fileName={file.name}/>
                }
                {type === AttachmentType.Image && url && <WhiteBoardWrapper
                    id={file.id}
                    width={904}
                    height={508}
                    imageUrl={url}
                    rotate={file.rotate}
                    canvas={file.canvas?.length > 0 ? file.canvas[0] : {}}
                    cancelCanvas={this.cancelCanvas}
                    isCanvasEditable={isCanvasEditable}
                    page={0}
                />
                }

                {video && <VideoPlayer url={video}/>}
            </Fragment>
        );
    }
}

LessonPreviewContent.propTypes = {
    onClose: PropTypes.func,
    file: PropTypes.object,
    video: PropTypes.string
};

export default LessonPreviewContent;
